module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-19-a166da14f9c58589952b87ab6268c683.jpg";